import constants from '../constants';
import api from '../../utils/api';
import User from '../../models/User';
import { logError } from '@zg-rentals/log-error';

const UserActions = {
  getUser({ pageWithSensitiveInformation = false } = {}) {
    return (dispatch) => {
      return dispatch(api.user.info({ pageWithSensitiveInformation }))
        .then((response = {}) => {
          const userModel = User(response);

          dispatch(UserActions.updateUserInfo(userModel));

          return userModel;
        })
        .catch((err) => {
          logError({
            error: err,
            errorType: 'GetUser',
            context: {
              location: 'UserActions#getUser',
            },
          });
          return User();
        });
    };
  },
  updateUserInfo(data) {
    return (dispatch) => {
      return dispatch({
        type: constants.UPDATE_USER_INFO,
        payload: data,
      });
    };
  },
};

export default UserActions;
